import React from "react";
import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";
import MenuCard from "./MenuCard";

const HomePageContainer = styled("div")({
  width: "100%",
  justifyContent: "center",
  alignItems: "center",
  padding: "2rem",
});

const Home: React.FC = () => {
  return (
    <HomePageContainer>
      <Grid container spacing={3} columns={{ sm: 6, md: 8, lg: 12 }} sx={{ paddingBottom: "2rem" }}>
        <MenuCard
          title="Logic Tree"
          text="Logic Tree Viewer."
          img="/images/source_branches_thumb.png"
          url="/LogicTree"
        />
        <MenuCard title="Search" text="Search for Toshi objects." img="/images/search_thumb.png" url="/Search" />
        <MenuCard
          title="My Solutions"
          text="View your favourite solutions."
          img="/images/my_solutions_thumb.png"
          url="/Favourites"
        />
      </Grid>
    </HomePageContainer>
  );
};

export default Home;
